import { render, staticRenderFns } from "./ChallengerDetailDescriptionTrophy.vue?vue&type=template&id=3f638ec2&scoped=true"
import script from "./ChallengerDetailDescriptionTrophy.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailDescriptionTrophy.vue?vue&type=script&lang=ts"
import style0 from "./ChallengerDetailDescriptionTrophy.vue?vue&type=style&index=0&id=3f638ec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f638ec2",
  null
  
)

export default component.exports